import type { StyleRule } from '@archipro-design/aria';
import { inputClassName } from '@archipro-design/aria';
import { pxToRem } from '@archipro-design/aria';
import {
    pxArrayToRem,
    captionClassName,
    buttonClassName,
    labelClassName,
    subscriptionClassName,
} from '@archipro-design/aria';

export const Container: StyleRule = ({ theme }) => ({
    [theme.screen.laptop]: {
        padding: pxArrayToRem([50, 0, 0]),
    },
});

export const Subscription: StyleRule = ({ theme }) => ({
    [`&.${subscriptionClassName}`]: {
        [`& > .${captionClassName}:first-child`]: {
            display: 'none',
        },

        [`& .${inputClassName} input:-webkit-autofill`]: {
            '-webkit-box-shadow': `0 0 0 30px ${theme.siteVariables.bodyBackground} inset`,
            '-webkit-text-fill-color': theme.siteVariables.colors.charcoal[250],
            'caret-color': theme.siteVariables.colors.charcoal[250],
        },

        [`& .${inputClassName} input`]: {
            height: pxToRem(40),
            padding: 0,
        },

        [`& .${buttonClassName}`]: {
            minWidth: pxToRem(134),
            padding: pxArrayToRem([12, 20]),
            margin: 0,
            background: theme.siteVariables.colors.charcoal[250],

            [`&:hover`]: {
                background: theme.siteVariables.colors.charcoal[200],
            },

            [`& > .${labelClassName}`]: {
                fontSize: pxToRem(16),
                width: 'unset',
            },
        },
    },
});

export const SuccessMsg: StyleRule = ({ theme }) => ({
    [`&.${captionClassName}`]: {
        color: theme.siteVariables.colors.success[200],
    },
});
